module.exports = __webpack_public_path__ + "img/dfod-logo.9ccda49b.svg";